export const MODAL_OPEN = 'MODAL_OPEN'
export const RESET_PASS_TOKEN = 'RESET_PASS_TOKEN'
export const STORE_USER = 'STORE_USER'
export const AUTH_TOKEN = 'AUTH_TOKEN'
export const CALL_STATUS = 'CALL_STATUS'
export const WS_EVENT = 'WS_EVENT'
